import React from "react";
import { getTranslations } from "../../Common/utils";

const LeagueManageTabs = ({ activeTab, onTabChange }) => {
  const activeClass = (id) => {
    return activeTab === id ? "si-active" : "";
  };

  const tabs = [
    {
      id: "players",
      label: getTranslations("league_manage_tab_players", "Players"),
    },
    {
      id: "edit-league",
      label: getTranslations("league_manage_tab_edit_league", "Edit League"),
    },
  ];

  return (
    <div className="si-tabs__wrap">
      <ul>
        {tabs.map((tab) => (
          <li key={tab.id}>
            <button
              onClick={() => onTabChange(tab.id)}
              className={activeClass(tab.id)}
              aria-label={tab.label}
              aria-selected={activeTab === tab.id}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LeagueManageTabs;